module.exports = __webpack_public_path__ + "static/media/001.f7be5e43.jpg";